import type { ModelRegistry } from 'ember-data/types/registries/model';

export function getPreferredMessagingChannel(
  channel: string,
  messagingChannels: ModelRegistry['messaging-channel'][],
): string {
  const preferred = channel === 'uplisting' ? 'email' : channel;
  const enabled = messagingChannels.filter((ch) => ch.enabled);

  return (
    enabled.find((ch) => ch.id === preferred)?.id ?? enabled[0]?.id ?? preferred
  );
}
